module.exports = {
      id: "comm-health-usage",
      viewBox: "0 0 321.539 50.773",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#comm-health",
      toString: function () {
        return this.url;
      }
    }